import BookItem from "@app/components/book-item";
import Pagination from "@app/components/pagination";
import ChevronDownArrow from "@app/components/select/chevron-down";
import { CustomSelect } from "@app/components/select/custom-select";
import SkeletonGrid from "@app/components/skeleton-grid";
import {
  BannerAdsPosition,
  BookOptionOptionByName,
  DEFAULT_PAGE,
  RoutePath,
  SortOptionOptions,
} from "@app/constants";
import BookService from "@app/services/http/book.service";
import {
  Book,
  BookOptionOption,
  GetBookOptionRequestParams,
  Meta,
  SortOption,
} from "@app/types";
import { Images } from "@assets/images";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import BannerAdsComponent from "../home/components/banner-ads";

function BookOption() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { abortController } = useCancellationRequest();

  const [title, setTitle] = useState("");
  const [books, setBooks] = useState<Book[]>([]);
  const [requestParams, setRequestParams] =
    useState<GetBookOptionRequestParams>({
      pageNum: DEFAULT_PAGE,
      pageSize: 50,
      sortOption: SortOption.POSTED_DATE,
    });
  const [meta, setMeta] = useState<Meta>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const option = searchParams.get("option")
      ? String(searchParams.get("option"))
      : "";

    if (
      option !== BookOptionOption.FREE.toString() &&
      option !== BookOptionOption.VIP.toString()
    ) {
      return navigate(RoutePath.HOME);
    }

    setTitle((BookOptionOptionByName as any)[`${option}`]);

    const newRequestParams: GetBookOptionRequestParams = {
      ...requestParams,
      bookOption: (option as any) ?? BookOptionOption.FREE,
    };

    BookService.getBookOption(newRequestParams, abortController.signal)
      .then((res) => {
        setBooks(res.data.items);
        setMeta(res.data.meta);

        if (
          requestParams.pageNum &&
          res.data.meta.totalPage > 0 &&
          res.data.meta.totalPage < requestParams.pageNum
        ) {
          const newRequestParams: GetBookOptionRequestParams = {
            ...requestParams,
            pageNum: DEFAULT_PAGE,
          };

          setRequestParams(newRequestParams);
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchParams.get("option"), requestParams]);

  const onPageChange = (page: number) => {
    const newRequestParams: GetBookOptionRequestParams = {
      ...requestParams,
      pageNum: page,
    };

    setRequestParams(newRequestParams);
  };

  const onSortByChange = (e: string | number) => {
    const newRequestParams: GetBookOptionRequestParams = {
      ...requestParams,
      sortOption: e as SortOption,
    };

    setRequestParams(newRequestParams);
  };

  return (
    <div className="px-[100px] min-h-[calc(100vh-328px)]">
      <div className="mt-[66px] flex items-center justify-between gap-3">
        <div className="text-[#171A20] font-[SVN-Gilroy] font-bold text-[32px]">
          {title}
        </div>
        <CustomSelect
          className="!border-[#616E87] pr-2 w-[200px]"
          options={SortOptionOptions}
          optionContainerClassName="top-[34px] w-[200px]"
          optionClassName="!min-h-[35px] text-sm text-[#3A4251] font-semibold tracking-[0.028px] whitespace-nowrap px-2 font-[SVN-Gilroy]"
          labelSelectedClassName="text-[#3A4251] text-sm font-semibold tracking-[0.028px] font-[SVN-Gilroy]"
          arrow={<ChevronDownArrow />}
          defaultValue={SortOption.POSTED_DATE.toString()}
          hasBgColorHover
          onChange={onSortByChange}
        />
      </div>
      {!loading && books.length ? (
        <div>
          <div className="mt-9 flex flex-wrap gap-6">
            {books.map((book) => (
              <div key={book.id}>
                <BookItem book={book} />
              </div>
            ))}
          </div>
          {meta && (
            <div className="flex justify-center mt-3">
              <Pagination
                currentPage={meta.pageNum}
                totalPages={meta.totalPage}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </div>
      ) : !loading ? (
        <div className="mt-[164px] flex flex-col items-center">
          <img
            className="w-[120px]"
            src={Images.ResultNotFound.default}
            alt=""
          />
          <div className="font-[SVN-Gilroy] font-semibold tracking-[0.024px] text-[#171A20]">
            Không tìm thấy kết quả nào
          </div>
        </div>
      ) : (
        <div className="mt-9">
          <SkeletonGrid />
        </div>
      )}
      {String(searchParams.get("option")) ===
        BookOptionOption.FREE.toString() && (
        <BannerAdsComponent
          className="mt-[60px]"
          position={BannerAdsPosition.BOOK_FREE_SCREEN}
        />
      )}
    </div>
  );
}

export default BookOption;
